import React from 'react';
import { cn } from '@/lib/utils';
interface Tab {
  label: string;
  value: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onUpdateActiveTab: (value: string) => void;
  clsWrapper?: string;
  redPointNum?: { [key: string]: number };
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onUpdateActiveTab,
  clsWrapper,
  redPointNum
}) => {
  return (
    <div className={cn('mb-3 px-4', clsWrapper)}>
      <div className="flex gap-4">
        {tabs.map(tab => (
          <div
            key={tab.value}
            className="relative flex cursor-pointer flex-col items-center gap-1"
            onClick={() => onUpdateActiveTab(tab.value)}
          >
            {redPointNum?.[tab.value] > 0 && (
              <div
                className={`absolute top-[-5px] rounded-full bg-red-500 px-1 text-xs text-white ${
                  redPointNum?.[tab.value] < 10
                    ? 'right-[-10px]'
                    : redPointNum?.[tab.value] > 9
                    ? 'right-[-16px]'
                    : redPointNum?.[tab.value] > 99
                    ? 'right-[-22px]'
                    : 'right-[-26px]'
                }`}
              >
                {redPointNum?.[tab.value]}
              </div>
            )}
            <span
              className={`text-sm font-medium transition-colors ${
                activeTab === tab.value ? 'text-[#5959EB]' : 'text-[#1F1F1F]'
              }`}
            >
              {tab.label}
            </span>
            {activeTab === tab.value && <div className="h-1 w-[18px] rounded-full bg-[#5959EB]" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
